import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AttachmentHttpService } from './attachment.http.service';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { Attachment } from '../../models/attachment';
import { List } from 'immutable';
import { OnyxEvent } from '../../models/event';

@Injectable()
export class AttachmentStore {

  private currentAttachments: BehaviorSubject<List<Attachment>> = new BehaviorSubject(List([]));

  constructor(private attachmentHttpService: AttachmentHttpService,
              private flashMessagesService: FlashMessagesService) {
  }

  get attachments(): Observable<any> {
    return this.currentAttachments.asObservable();
  }

  loadAttachments(eventId: number, eventPartyId: number, multiVendor: boolean): void {
    if (multiVendor) {
      this.getAttachments(eventId).subscribe();
    } else {
      this.getAttachmentsByParty(eventId, eventPartyId).subscribe();
    }
  }


  getAttachments(eventId: number): Observable<List<Attachment>> {
    return this.attachmentHttpService.getForEvent(eventId)
      .catch((error: any) => {
        // Catch error here so resolver also displays error.
        this.flashMessagesService.error('MESSAGES.ERROR.GET_ATTACHMENTS', `Error retrieving attachments; ${error}`);
        return Observable.throw(error);
      })
      .map((res: List<Attachment>) => {
        this.currentAttachments.next(List(res));
        return res;
      });
  }

  getAttachmentsByParty(eventId: number, eventPartyId: number): Observable<List<Attachment>> {
    return this.attachmentHttpService.getForEventByParty(eventId, eventPartyId)
      .catch((error: any) => {
        // Catch error here so resolver also displays error.
        this.flashMessagesService.error('MESSAGES.ERROR.GET_ATTACHMENTS', `Error retrieving attachments; ${error}`);
        return Observable.throw(error);
      })
      .map((res: List<Attachment>) => {
        this.currentAttachments.next(List(res));
        return res;
      });
  }

  addAttachment(eventId: number, eventPartyId: number, file: File, multiVendor: boolean): Observable<any> {
    return this.attachmentHttpService.add(eventId, eventPartyId, file)
      .map((res) => {
        this.loadAttachments(eventId, eventPartyId, multiVendor);
        return res;
      });
  }

  deleteAttachment(eventId: number, eventPartyId: number, uniqueId: string, multiVendor: boolean): Observable<any> {
    return this.attachmentHttpService.delete(uniqueId)
      .map((res) => {
        this.loadAttachments(eventId, eventPartyId, multiVendor);
        return res;
      });
  }

  get(uniqueId: string): Observable<string> {
    return this.attachmentHttpService.get(uniqueId)
      .map((res: string) => {
        window.open(res);
        return res;
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/attachment/attachment.store.ts